import { render, staticRenderFns } from "./QuestionBase.vue?vue&type=template&id=ae43cb22&scoped=true&"
import script from "./QuestionBase.vue?vue&type=script&lang=js&"
export * from "./QuestionBase.vue?vue&type=script&lang=js&"
import style0 from "./QuestionBase.vue?vue&type=style&index=0&id=ae43cb22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae43cb22",
  null
  
)

export default component.exports